module.exports = __webpack_public_path__ + "images/stephen_zargham.jpg?v=9d06c26c09a955b68ec7b7991678f7d9";